import * as Diagram from "../../../../components/diagram";

const levelColumns = [
  {
    key: "結案原因",
    isNumber: true,
  },
];

export const VillageSecondCaseClosed = {
  label: "18鄉鎮二期結案總量暨原因分析",
  key: "VillageSecondCaseClosed",
  path: "BoneMuscleCare/VillageSecondCaseClosed",
  api: "TCS_V_SecondCaseColsedReason",
  render: (options) => (
    <Diagram.BoneMuscleCare.VillageSecondCaseClosed {...options} />
  ),
  countKey: "cnt",
  isPercent: true,
  isColSum: true,
  isRowSum: true,
  isGroup: true,
  groupColumns: [
    {
      key: "鄉鎮",
      field: "鄉鎮",
      header: "",
    },
  ],
  dateRangeColumns: [{ label: "篩檢日期", key: "篩檢日期" }],
  levelColumns,
  columns: [],
};
